import { render, staticRenderFns } from "./CompanyAssetAddresses.vue?vue&type=template&id=0b04ec1c"
import script from "./CompanyAssetAddresses.vue?vue&type=script&lang=js"
export * from "./CompanyAssetAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports